module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-fixed-top navbar-white shrink",
    attrs: {
      "id": "navigation"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "navbar-header col-md-4"
  }, [_c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand page-scroll font-family-alt letter-spacing-1 text-extra-large text-uppercase",
    on: {
      "click": function($event) {
        _vm.goToMenuItem('home-bg-video')
      }
    }
  }, [_c('div', [_vm._v("\n                        VW ERHVERVSKLUB\n                        "), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("\n                            " + _vm._s(this.$route.meta.retailerName) + "\n                        ")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMenu),
      expression: "showMenu"
    }],
    staticClass: "navbar-collapse collapse in col-md-8 pull-right",
    attrs: {
      "id": "navbar-deveo"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav font-family-alt letter-spacing-1 text-small text-uppercase"
  }, [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToMenuItem('about')
      }
    }
  }, [_vm._v("Praktiske informationer")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToMenuItem('venue')
      }
    }
  }, [_vm._v("Få inspiration")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToMenuItem('ticket')
      }
    }
  }, [_vm._v("Pris")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToMenuItem('register')
      }
    }
  }, [_vm._v("Tilmelding")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToMenuItem('contact')
      }
    }
  }, [_vm._v("Kontakt")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30b40666"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/top-menu.vue
// module id = 237
// module chunks = 1